import React, { memo, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import FieldSelect from 'containers/components/Fields/Select';
import { getLiteral } from 'utils/getLiteral';

const propTypes = {
    field: PropTypes.object.isRequired,
    description: PropTypes.string,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    desc: PropTypes.string,
    mandatory: PropTypes.bool,
    readOnly: PropTypes.bool,
    hidden: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    tooltip: PropTypes.string,
};

const CompanyValueListField = memo(
    ({ field, description, id, desc, mandatory, readOnly, hidden, onChange, tooltip }) => {
        // Fields/Select expects { value, label } or a primitive. If we only have id (no desc),
        // pass the primitive so SelectHoi resolves the label via getEntityValue.
        const selectValue = useMemo(() => {
            if (id === null || id === undefined || id === '' || id === '-1' || id === -1)
                return undefined;
            const valueId = String(id);
            if (desc !== undefined && desc !== null && desc !== '') {
                return { value: valueId, label: desc };
            }
            return valueId;
        }, [id, desc]);

        const handleChange = useCallback(
            (option) => {
                const isObject = option && typeof option === 'object';
                const id = isObject ? option.value : option;
                const description = isObject ? option.label : '';
                onChange(field.id, { id: id ?? '', description: description ?? '' });
            },
            [field, onChange],
        );

        if (hidden) return null;

        return (
            <div className="fm-company-valuelist-field">
                <FieldSelect
                    label={description}
                    labelMode="horizontal"
                    list={field.valueListName}
                    value={selectValue}
                    mandatory={mandatory}
                    readOnly={readOnly}
                    isClearable={field.hideClear ? false : true}
                    onChange={handleChange}
                    description={tooltip ? getLiteral(tooltip) : undefined}
                />
            </div>
        );
    },
);

CompanyValueListField.propTypes = propTypes;
export default CompanyValueListField;
